import { render } from "./modell-selector.vue?vue&type=template&id=f5bd2e10"
import script from "./modell-selector.vue?vue&type=script&lang=js"
export * from "./modell-selector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__